/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'
import type { DatePickerProps as AntDatePickerProps } from 'antd'
import { DatePicker as AntDatePicker } from 'antd'
import { CalendarOutlined } from '@ant-design/icons'
import Text from '../Text'
import { paragraphMedium, weightRegular } from 'src/components/css'

type DatePickerProps = {
  label: string
  value: AntDatePickerProps['value']
  onChange: AntDatePickerProps['onChange']
}

const DatePicker = ({ label, value, onChange }: DatePickerProps) => {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
        flex: 1 0 0;
        @media (max-width: 768px) {
          width: 100%;
        }
      `}
    >
      <Text variant='paragraphSmall' weight='regular' color={colors.WHITE}>
        {label}
      </Text>
      <AntDatePicker
        value={value}
        onChange={onChange}
        inputReadOnly
        css={css`
          height: 36px !important;
          ${paragraphMedium}
          ${weightRegular}
          width: 100%;
          border-radius: 8px;
          border: 1px solid ${colors.SECONDARY_100};
          background: ${colors.SECONDARY_200};
        `}
        getPopupContainer={(triggerNode) => {
          return triggerNode.parentNode as HTMLElement
        }}
        suffixIcon={
          <CalendarOutlined
            css={css`
              color: ${colors.WHITE};
              font-size: 24px;
            `}
          />
        }
        popupStyle={{ position: 'fixed' }}
      />
    </div>
  )
}

export default DatePicker
